/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();import { MtaStoryblokTypes } from '@mta/vela-api-types'
import { useTranslations } from 'next-intl'
import React from 'react'

/** A description of the available properties for this component. */
type ComplexityPillProps = Pick<MtaStoryblokTypes.ActivityStoryblok, 'complexity'>

/**
 * Component to render pill containers based on an activity's complexity.
 */
const ComplexityPill: React.FC<ComplexityPillProps> = ({ complexity }) => {
  const t = useTranslations('ComplexityPill')
  if (!complexity || complexity.length === 0) {
    return null
  }

  const complexityColors = {
    introductory: 'bg-green-100 text-green-700',
    intermediate: 'bg-blue-100 text-blue-700',
    advanced: 'bg-red-100 text-red-700',
  }

  return (
    <div className='flex space-x-2'>
      {complexity.map((level) => (
        <span
          key={level}
          className={`px-3 py-1 rounded-full text-xs font-semibold ${complexityColors[level]} whitespace-nowrap`}
        >
          {t(level)}
        </span>
      ))}
    </div>
  )
}

export { ComplexityPill }
